import { actionCreator } from '@ardoq/rxbeach';

export const futureStateGraphSelectionChanged = actionCreator<string | null>(
  '[futureState] graph selection changed'
);

export const futureStateProposalSelectionToggled = actionCreator<string | null>(
  '[futureState] proposal selection toggled'
);

export const futureStateGraphSelectionChangedWithoutZoom = actionCreator<
  string | null
>('[futureState] graph selection changed without zoom');
